import { render, staticRenderFns } from "./EditContactinfo.vue?vue&type=template&id=15517656&"
import script from "./EditContactinfo.vue?vue&type=script&lang=js&"
export * from "./EditContactinfo.vue?vue&type=script&lang=js&"
import style0 from "./EditContactinfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports